import { Injectable } from '@angular/core';
import { URLSearchParams,Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ApiService } from '../shared/services/api.service';
import { RequestOptions, Request, RequestMethod } from '@angular/http';

@Injectable()
export class StaffService {
  baseURL =  "/api/mvp"
  constructor(
    private apiService: ApiService
  ) { }

  getDepartmaents() {
    //return this.apiService.get(this.baseURL+'/companyuser/department/list/'+false)
    return this.apiService.get(this.baseURL+'/companyuser/department/list/null'+false)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
  getDesignations(data) {
    // get/designationsbydepartment
    // /get/designations
    return this.apiService.get(this.baseURL+'/get/designationsbydepartment',data)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
  getBuckets() {
    return this.apiService.get(this.baseURL+'/bucketmaster')
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }

  getProducts() {
    return this.apiService.get(this.baseURL + '/get/primaryCategoryItems?categoryMasterId=4EE68207B1F6468F865511BC41A907D6')
      .map(
      (response: Response) => {
        return response;
      }
      )
      .catch(
      (error: Response) => {
        return Observable.throw('Something went wrong');
      }
      );
  }
  getBaseBranches() {
    return this.apiService.get('/api/mvp/get/basebranches')
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
  getStaff(obj) {
    return this.apiService.get( '/api/mvp/collectionstaff/list/'+obj)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }

  getAgencies(data) {
    return this.apiService.get(this.baseURL + '/agencies/byname/' + data).
      map(
        (response: [Response]) => {
          return response;
        }
      );
  }

  getSupervisor(data) {
    console.log(data)
    return this.apiService.get(this.baseURL + '/collectionstaff/byname/' + data).
      map(
        (response: [Response]) => {
          return response;
        }
      );
  }

  fetchAgencies() {
    return this.apiService.get('/api/mvp/agencylist')
      .map(
      data => {
        return data;
      }
      );
  }

  getCollectionStaffs(data){
    return this.apiService.get(this.baseURL+'/collectionstaff/byname/a'+data)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
  getStaffList(data){
	console.log(data);
    return this.apiService.post('/api/mvp/staff/collection/search',data)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
  getStaffDetails(data){
    return this.apiService.get('/api/mvp/staff/collection/'+data)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
  fetchStates() {
     return this.apiService.getRawJson('states.json')
       .map(res => res);
   }
   fetchCities(state: string) {
   return this.apiService.getRawJson(`${state}.json`)
     .map(res => res);
 }

  postStaffDetails(data) {
	console.log(data);
    return this.apiService.post( '/api/mvp/staff/collection/create', data)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }

  postStaffEditDetails(data) {
    return this.apiService.put( '/api/mvp/staff/collection/edit', data)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
  
   postDeactivatedReason(submitDeactivatedDetails) {
    return this.apiService.post( '/api/mvp/staff/collection/deactivate', submitDeactivatedDetails)
      .map(
        (response: Response) => {
          return response;
        }
      )
      .catch(
        (error: Response) => {
          return Observable.throw('Something went wrong');
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/staff/staff.service.ts